export const setUpVoices = (voices) => {
    let arrayVoice = [];
    voices.forEach(voice =>
        arrayVoice.push({
            value: voice.id,
            text:<span style={{maxWidth : "300px"}}> <i style={{ marginRight: '15px',fontSize: "12px" }} className={'flag-icon flag-icon-' + voice.country}></i><div className="channel_content_dropdown" style={{fontSize: "14px" }}>  {voice.value} </div></span>
        })
    )
    return arrayVoice;
}